module.exports = __webpack_public_path__ + "img/H3.45ed32dd.png";